import React from "react";
import Page from "../../common/page/Page";
import CandidatesBlock from "./CandidatesBlock";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized";
import useAuthUser from "../../authentication-no-ui/useAuthUser";
import useTranslationCandidates from "../useTranslationCandidates";
import useShowLoader from "../../common/loading-widgets/useShowLoader";

export default function CandidatesPage(props) {
  const { profile: recruiter } = useAuthUser();
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="CandidatesPage">
          <Page.Title
            text={t("candidates:candidates_page_title")}
            loading={tLoading}
          />
          <Page.Content>
            <CandidatesBlock recruiterId={recruiter._id} />
          </Page.Content>
        </Page>
      )}
    />
  );
}
